import styled, { keyframes } from 'styled-components';

const animateLineTip = keyframes`
  0% {
    background-color: #fff;
    top: 1.1875em;
    left: .0625em;
    width: 0;
  } 54% {
    top: 1.0625em;
    left: .125em;
    width: 0;
  } 70% {
    top: 2.1875em;
    left: -.375em;
    width: 3.125em;
  } 84% {
    top: 3em;
    left: 1.3125em;
    width: 1.0625em;
  } 100% {
    background-color: #60bb71;
    top: 2.8125em;
    left: .875em;
    width: 1.5625em;
  }
`;

const animateLineLong = keyframes`
  0% {
    background-color: #fff;
    top: 3.375em;
    right: 2.875em;
    width: 0;
  } 65% {
    top: 3.375em;
    right: 2.875em;
    width: 0;
  } 84% {
    top: 2.1875em;
    right: 0;
    width: 3.4375em;
  } 100% {
    background-color: #60bb71;
    top: 2.375em;
    right: .5em;
    width: 2.9375em;
  }
`;

const animateCircularLine = keyframes`
  0% {
    transform: rotate(-45deg);
  } 5% {
    transform: rotate(-45deg);
  } 12% {
    transform: rotate(-405deg);
  } 100% {
    transform: rotate(-405deg);
  }
`;

const SuccessIconContainer = styled.div`
  position: relative;
  box-sizing: content-box !important;
  justify-content: center;
  width: 5em;
  height: 5em;
  margin: .25em auto .85em;
  zoom: normal;
  border: .275em solid #28a745;
  border-radius: 50%;
  cursor: default;
  user-select: none;
  display: flex;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: block !important;
    justify-content: space-between !important;
    align-items: center !important;
  }
`;

const SuccessIconCircleLineLeft = styled.div`
  position: absolute;
  width: 3.75em;
  height: 7.5em;
  transform: rotate(45deg);
  border-radius: 50%;
  top: -.4375em;
  left: -2.0635em;
  transform: rotate(-45deg);
  transform-origin: 3.75em 3.75em;
  border-radius: 7.5em 0 0 7.5em;
  background-color: rgb(255, 255, 255);
`;

const SuccessIconCircleLineRight = styled.div`
  position: absolute;
  width: 3.75em;
  height: 7.5em;
  transform: rotate(45deg);
  border-radius: 50%;
  top: -.6875em;
  left: 1.875em;
  transform: rotate(-45deg);
  transform-origin: 0 3.75em;
  border-radius: 0 7.5em 7.5em 0;
  background-color: rgb(255, 255, 255);
  animation-name: ${animateCircularLine};
  animation-timing-function: ease-in;  
  animation-duration: 4.25s;  
  animation-delay: .45s;
`;

const SuccessIconFix = styled.div`
  position: absolute;
  z-index: 1;
  top: .5em;
  left: 1.625em;
  width: .4375em;
  height: 5.625em;
  transform: rotate(-45deg);
  background-color: rgb(255, 255, 255);
`;

const SuccessIconLineTip = styled.span`
  display: block;
  position: absolute;
  z-index: 2;
  height: .3125em;
  border-radius: .125em;
  background-color: #fff;
  top: 2.875em;
  left: .875em;
  width: 1.5625em;
  transform: rotate(45deg);
  animation-name: ${animateLineTip};
  animation-duration: .75s;  
  animation-delay: .45s;
  animation-fill-mode: forwards;
`;

const SuccessIconLineLong = styled.span`
  display: block;
  position: absolute;
  z-index: 2;
  height: .3125em;
  border-radius: .125em;
  background-color: #fff;
  top: 2.375em;
  right: .5em;
  width: 2.9375em;
  transform: rotate(-45deg);
  animation-name: ${animateLineLong};
  animation-duration: .75s;  
  animation-delay: .45s;
  animation-fill-mode: forwards;
`;

const SuccessIconRing = styled.div`
  position: absolute;
  z-index: 2;
  box-sizing: content-box !important;
  width: 97%;
  height: 97%;
  border: .25em solid rgba(96, 187, 113, 0.6);
  border-radius: 50%;
`;

export {
  SuccessIconContainer,
  SuccessIconCircleLineLeft,
  SuccessIconLineTip,
  SuccessIconLineLong,
  SuccessIconRing,
  SuccessIconFix,
  SuccessIconCircleLineRight,
};